import React, { memo } from 'react';
import { Flex, Text } from 'onefaceui-react-components';
import PropTypes from 'prop-types';

function StatusCaptionItem({
  type,
  title,
  captionItemLabelClassname,
  onClick,
  unchecked,
  captionItemLabelStyle,
  style,
  children
}) {
  return (
    <Flex
      style={style}
      alignItems="center"
      onClick={onClick}
      className={unchecked ? 'filter-type unchecked' : 'filter-type'}
      gap={4}
      title={title}
      data-testid={`item-${type}`}
    >
      {children || (
        <>
          <div
            style={captionItemLabelStyle}
            className={`${captionItemLabelClassname}`}
          />
          <Text size="xs">{title}</Text>
        </>
      )}
    </Flex>
  );
}

StatusCaptionItem.propTypes = {
  type: PropTypes.string,
  title: PropTypes.string,
  captionItemLabelClassname: PropTypes.string,
  onClick: PropTypes.func,
  unchecked: PropTypes.bool,
  style: PropTypes.shape({}),
  captionItemLabelStyle: PropTypes.shape({}),
  children: PropTypes.node
};
StatusCaptionItem.defaultProps = {
  title: '',
  type: '',
  unchecked: false,
  style: {},
  captionItemLabelStyle: {},
  captionItemLabelClassname: '',
  onClick: () => {},
  children: null
};

export default memo(StatusCaptionItem);
